import Show from '../show'

const RqDashboard = () => {
  return (
    <Show
      title="Requisitions Dashboard"
      dashboardKey="rq_dashboards"
      showYear={false}
    />
  )
}

export default RqDashboard
